module.exports = __webpack_public_path__ + "img/media-kaya-network-1.1fe33561.png";